import { environment } from '../../../../environments/environment';
// import * as angular from 'angular';

(function () {
  'use strict';

  angular.module('app').service('SaleChannelService', SaleChannelService);

  SaleChannelService.$inject = [
    'RestResource',
    'CONFIGURATIONS',
    '$translate',
    '$filter',
    'UtilService',
    'SessionService',
    'TranslationModalService',
    'WindowModalService',
  ];

  function SaleChannelService(
    RestResource,
    config,
    $translate,
    $filter,
    UtilService,
    SessionService,
    TranslationModalService,
    WindowModalService
  ) {
    var utils = new UtilService(this);

    $translate = $filter('translate');

    var apiUrl = environment.apiEndpoint + 'companies';

    var service = {
      getFilterCriteria: getFilterCriteria,
      getSaleChannel: getSaleChannel,
      saveSaleChannel: saveSaleChannel,
      openSaleChannelModal: openSaleChannelModal,
      changeSaleChannelStatus: changeSaleChannelStatus,
      setDefaultSaleChannel: setDefaultSaleChannel,
      setDefaultSaleSource: setDefaultSaleSource,
      openSaleChannelTranslations: openSaleChannelTranslations,
      deleteSaleChannel: deleteSaleChannel,
    };

    return service;

    ////////////////

    function getFilterCriteria() {
      var filterCriteria = {
        page: 1,
        sortDir: 'asc',
        sortedBy: 'name',
      };

      return filterCriteria;
    }

    function getSaleChannel(id, language, translate) {
      var params;
      if (language) {
        params = {
          lang: language,
        };
      }

      if (translate) {
        params.get = 'translate';
      }

      var url =
        apiUrl + '/' + SessionService.getSelectedAccountCompany().id + '/sale_channels/' + id;

      return RestResource.request(
        'get',
        url,
        params,
        function (response) {
          return response.data;
        },
        function () {
          return false;
        }
      );
    }

    function saveSaleChannel(saleChannel, language) {
      var url = apiUrl + '/' + SessionService.getSelectedAccountCompany().id + '/sale_channels';
      var method = 'post';

      if (saleChannel.id) {
        // edit
        url += '/' + saleChannel.id;
        method = 'put';
      }

      var lang = language ? language : config.DEFAULT_CONTENT_LANGUAGE;

      function success(response) {
        var msg = !saleChannel.id ? 'SALE_CHANNEL_ADDED' : 'SALE_CHANNEL_MODIFIED';
        utils._successMsg($translate(msg));

        return {
          status: true,
          response: response.data,
        };
      }

      function failure(response) {
        return {
          status: false,
          response: response.data,
        };
      }

      return RestResource.request(
        method,
        url,
        { sale_channel: saleChannel, lang: lang },
        success,
        failure
      );
    }

    function openSaleChannelModal(
      saleChannel,
      mode,
      defaultLanguage,
      additionalLanguages,
      company,
      successCallback
    ) {
      var templateUrl = './app/ajs/sale-channels/modals/sale-channel-detail-modal.html';

      var originalItem = angular.copy(saleChannel);

      var modalParams = {
        title: 'SALE_CHANNEL_DETAILS',
        item: originalItem,
        mode: mode,
        defaultLanguage: defaultLanguage,
        additionalLanguages: additionalLanguages,
        parentOptions: company,
        preventModalClose: true,
      };

      // if (!saleChannel.id){
      //     modalParams.closeOnSave = false; // Do not close modal after create
      // }

      // onSavedItem in modal service
      var confirmCallback = function (response) {
        if (saleChannel.id) {
          // Edit
          saleChannel.name = response.name;
          saleChannel.description = response.description;
          saleChannel.is_channel = response.is_channel;
          saleChannel.is_source = response.is_source;
          saleChannel.is_website = response.is_website;
          saleChannel.is_default_channel = response.is_default_channel;
          saleChannel.is_default_source = response.is_default_source;

          saleChannel.website = response.website;
          saleChannel.website_id = response.website_id;
          saleChannel.user = response.user;
          saleChannel.user_id = response.user_id;

          return utils.itemListChanged(response.id);
        }

        return successCallback(response);
      };

      WindowModalService.open(templateUrl, modalParams, confirmCallback);
    }

    function openSaleChannelTranslations(saleChannel, additionalLanguages) {
      var template = './app/ajs/sale-channels/modals/sale-channel-detail-translation.html';

      var modalParams = {
        title: saleChannel.name,
        item: saleChannel,
        additionalLanguages: additionalLanguages,
      };

      var initializeCallback = function (itemId, language) {
        return getSaleChannel(itemId, language, 'translate').then(function (data) {
          return data;
        });
      };

      var confirmCallback = function (saleChannel, language) {
        return saveSaleChannel(saleChannel, language).then(function (data) {
          if (!data.status) {
            return data.response;
          }

          return false;
        });
      };

      TranslationModalService.open(template, modalParams, initializeCallback, confirmCallback);
    }

    function changeSaleChannelStatus(saleChannel) {
      var url =
        apiUrl +
        '/' +
        SessionService.getSelectedAccountCompany().id +
        '/sale_channels/' +
        saleChannel.id;

      var params = { title: null, body: null, successMsg: null };
      if (saleChannel.status === 'active') {
        params.title = 'DEACTIVATE_SALE_CHANNEL';
        params.body = 'DEACTIVATING_SALE_CHANNEL_WARNING';
        params.successMsg = 'SALE_CHANNEL_MODIFIED';
      }

      utils.changeItemStatus(url, saleChannel, params);
    }

    function setDefaultSaleChannel(saleChannel, successCallback) {
      var url =
        apiUrl +
        '/' +
        SessionService.getSelectedAccountCompany().id +
        '/sale_channels/' +
        saleChannel.id;

      saleChannel.is_default_channel = true;

      var params = {
        sale_channel: saleChannel,
        set_default_channel: true,
      };

      return RestResource.request(
        'put',
        url,
        params,
        function () {
          var msg = $translate('DEFAULT_SALE_CHANNEL_CHANGED');
          utils._successMsg(msg);

          return successCallback();
        },
        function (response) {
          utils._errorMsg(response.data.error);
          return false;
        }
      );
    }

    function setDefaultSaleSource(saleChannel, successCallback) {
      var url =
        apiUrl +
        '/' +
        SessionService.getSelectedAccountCompany().id +
        '/sale_channels/' +
        saleChannel.id;

      saleChannel.is_default_source = true;

      var params = {
        sale_channel: saleChannel,
        set_default_source: true, //saleChannel.is_default_source
      };

      return RestResource.request(
        'put',
        url,
        params,
        function () {
          var msg = $translate('DEFAULT_SALE_SOURCE_CHANGED');
          utils._successMsg(msg);

          return successCallback();
        },
        function (response) {
          utils._errorMsg(response.data.error);
          return false;
        }
      );
    }

    function deleteSaleChannel(saleChannel, successCallback, index) {
      var url =
        apiUrl +
        '/' +
        SessionService.getSelectedAccountCompany().id +
        '/sale_channels/' +
        saleChannel.id;

      var params = {
        title: 'DELETE_SALE_CHANNEL',
        body: 'DELETING_SALE_CHANNEL_WARNING',
        reason: 'DELETE_ITEM_REASON',
        successMsg: 'SALE_CHANNEL_DELETED',
      };

      utils.deleteItem(url, successCallback, params, index);
    }
  }
})();
